import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { ProgressState } from '../reducers/progress.reducer';
import * as selectors from '../selectors/progress.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProgressFacadeService extends FacadeService {
  constructor(public override store: Store<ProgressState>) {
    super(store);
  }

  // OBSERVABLES
  progressSpinner$ = this.storeSelect(selectors.getProgressSpinner);
  progressBar$ = this.storeSelect(selectors.getProgressBar);
  progressSearchSpinner$ = this.storeSelect(selectors.getProgressSearchSpinner);
  totalLoadRequests$ = this.storeSelect(selectors.getTotalLoadRequests);
  totalActionRequests$ = this.storeSelect(selectors.getTotalActionRequests);
  totalSearchRequests$ = this.storeSelect(selectors.getTotalSearchRequests);

  // OBSERVABLE'S VALUES
  get progressSpinner() {
    return this.storeSnapshot(this.progressSpinner$);
  }

  get progressBar() {
    return this.storeSnapshot(this.progressBar$);
  }

  get progressSearchSpinner() {
    return this.storeSnapshot(this.progressSearchSpinner$);
  }

  get totalLoadRequests() {
    return this.storeSnapshot(this.totalLoadRequests$);
  }

  get totalActionRequests() {
    return this.storeSnapshot(this.totalActionRequests$);
  }

  get totalSearchRequests() {
    return this.storeSnapshot(this.totalSearchRequests$);
  }
}
